import React, { useState } from 'react';
import { AlertTriangle, BarChart3, Bell, CheckCircle2, ChevronRight, CreditCard, FileCheck2, LayoutDashboard, Moon, RefreshCcw, Search, Send, ShieldCheck, Sun, WalletCards } from 'lucide-react';
import './paysysShowcase.css';
const metrics = [{
  label: 'Remittance received',
  value: '1,248',
  trend: '+12.8% today',
  icon: WalletCards
}, {
  label: 'Pending approvals',
  value: '86',
  trend: '18 high priority',
  icon: FileCheck2
}, {
  label: 'Failed queue',
  value: '42',
  trend: '9 eligible for retry',
  icon: AlertTriangle
}, {
  label: 'RTGS value',
  value: 'PKR 38.4M',
  trend: '+7.4% this week',
  icon: CreditCard
}];
const transactions = [['TXN-98421', 'RIA Money Transfer', 'PKR 850,000', 'Eligible for RTGS', 'Duplicate Transaction', 'High'], ['TXN-98422', 'MoneyGram', 'PKR 420,500', 'Retry', 'No HTTP Response Exception', 'Medium'], ['TXN-98423', 'InstantCash', 'PKR 120,000', 'Manual Settlement', 'Balance inquiry timeout', 'High'], ['TXN-98424', 'Western Union', 'PKR 75,250', 'Completed', 'Cleared by checker', 'Low']];
const navItems = [{
  label: 'Command Centre',
  icon: LayoutDashboard,
  active: true
}, {
  label: 'Transactions',
  icon: CreditCard
}, {
  label: 'Failed Queue',
  icon: AlertTriangle
}, {
  label: 'Approvals',
  icon: ShieldCheck
}, {
  label: 'Alerts',
  icon: Bell
}];
export default function PaysysDesignPreview() {
  const [darkMode, setDarkMode] = useState(false);
  return <div className={`paysys-showcase ${darkMode ? 'dark' : ''}`} data-id="element-4292" data-mp="13qyh3f6lfdx9">
      <div className="paysys-shell" data-id="element-4293" data-mp="yur81diwhmb3">
        <aside className="paysys-sidebar" data-id="element-4294" data-mp="usmgckc0izr3">
          <img className="paysys-logo" src="/paysys-logo.png" alt="Paysys" data-id="element-4295" data-mp="url5ogywsf9w" />
          <div className="paysys-user-card" data-id="element-4296" data-mp="pu2sgeduzdw3">
            <div className="paysys-avatar" data-id="element-4297" data-mp="pt9uo2wvnyq3">AM</div>
            <div data-id="element-4298" data-mp="3fjekj0ue4fxl">
              <strong data-id="element-4299" data-mp="3fjwo6ijdtwfj">Admin Maker</strong>
              <div className="paysys-subtitle" style={{
              margin: '3px 0 0'
            }} data-id="element-4300" data-mp="3fgse54j8k6gy">Backoffice operations</div>
            </div>
          </div>
          <nav className="paysys-nav" aria-label="Paysys preview navigation" data-id="element-4301" data-mp="3c0fs1fb7ss26">
            {navItems.map(item => {
            const Icon = item.icon;
            return <div className={`paysys-nav-item ${item.active ? 'active' : ''}`} key={item.label} data-id="element-4302" data-mp="3309ghyz2u25n">
                  <Icon size={18} data-id="element-4303" data-mp="371uop70o1s9i" />
                  {item.label}
                </div>;
          })}
          </nav>
        </aside>

        <main className="paysys-main" data-id="element-4304" data-mp="2t9oc1uwq23et">
          <header className="paysys-topbar" data-id="element-4305" data-mp="2t8mwpe8oaura">
            <div data-id="element-4306" data-mp="2y27xtf5kc4up">
              <p className="paysys-eyebrow" data-id="element-4307" data-mp="2y2r4fzprj6tf">Paysys design preview</p>
              <h1 className="paysys-title" data-id="element-4308" data-mp="2jd1rl78b5edb">Backoffice Command Centre</h1>
              <p className="paysys-subtitle" data-id="element-4309" data-mp="2obd2zme93wxn">
                A premium operational workspace for remittance monitoring, exception handling,
                approvals, alerts, and settlement workflows.
              </p>
            </div>
            <div className="paysys-actions" data-id="element-4310" data-mp="2f9na0c4q0pxr">
              <button className="paysys-button" onClick={() => setDarkMode(value => !value)} data-id="element-4311" data-mp="2fchuu4rnccrp">
                {darkMode ? <Sun size={16} data-id="element-4312" data-mp="1qpsa2bfyt9eh" /> : <Moon size={16} data-id="element-4313" data-mp="1qqbrlr1pdvrz" />}
                {darkMode ? 'Light mode' : 'Dark mode'}
              </button>
              <button className="paysys-button" data-id="element-4314" data-mp="24ptjwge7jr63">
                <RefreshCcw size={16} data-id="element-4315" data-mp="24ngx9pxi8smp" />
                Refresh
              </button>
              <button className="paysys-button primary" data-id="element-4316" data-mp="20molaox909mq">
                <Send size={16} data-id="element-4317" data-mp="2emzalniwtg5s" />
                Send to RTGS
              </button>
            </div>
          </header>

          <section className="paysys-grid metrics" aria-label="Backoffice metrics" data-id="element-4318" data-mp="29nv4x6v720k7">
            {metrics.map(metric => {
            const Icon = metric.icon;
            return <article className="paysys-card" key={metric.label} data-id="element-4319" data-mp="2jfisgwomqxge">
                  <div className="paysys-card-header" data-id="element-4320" data-mp="2xdz4n359hg5x">
                    <span className="paysys-label" data-id="element-4321" data-mp="2xeid7t90us7a">{metric.label}</span>
                    <span className="paysys-icon-tile" data-id="element-4322" data-mp="2sg77nuprf3uv"><Icon size={18} data-id="element-4323" data-mp="2sd2tq5mhstr0" /></span>
                  </div>
                  <div className="paysys-value" data-id="element-4324" data-mp="qp6xe6iqt3yg">{metric.value}</div>
                  <div className="paysys-trend" data-id="element-4325" data-mp="vojjgp1si6zz">{metric.trend}</div>
                </article>;
          })}
          </section>

          <section className="paysys-two-column" data-id="element-4326" data-mp="10gbbz54iamsr">
            <div data-id="element-4327" data-mp="14h50o0prw5mp">
              <div className="paysys-tabs" data-id="element-4328" data-mp="14hmuyrsvk9rz">
                {['All 20,841', 'Eligible for RTGS 22', 'Eligible for Cancel 60', 'Retry 7,994', 'Manual Settlement 18'].map((tab, index) => <button className={`paysys-tab ${index === 1 ? 'active' : ''}`} key={tab} data-id="element-4329" data-mp="cpp7toxmhmo1" data-mpi={index}>
                    {tab}
                  </button>)}
              </div>

              <div className="paysys-table-card" data-id="element-4330" data-mp="lqnc88bz3w75">
                <div className="paysys-toolbar" data-id="element-4331" data-mp="lsghpkauoadk">
                  <div className="paysys-actions" data-id="element-4332" data-mp="1s77o23iqsnez">
                    <input className="paysys-search" placeholder="Search transaction or reason" data-id="element-4333" data-mp="1s6fx5603bdv1" />
                    <select className="paysys-select" defaultValue="all" data-id="element-4334" data-mp="1x4hf1nls574x">
                      <option value="all" data-id="element-4335" data-mp="278xs697vka51">All lifecycle</option>
                      <option value="failed" data-id="element-4336" data-mp="22awbtw1u2ox9">Failed</option>
                      <option value="progress" data-id="element-4337" data-mp="22bo5307ykakd">In progress</option>
                    </select>
                  </div>
                  <button className="paysys-button" data-id="element-4338" data-mp="1xi36b5yjjck4">
                    <Search size={16} data-id="element-4339" data-mp="1thj8s1a226xg" />
                    Advanced filters
                  </button>
                </div>
                <div className="paysys-table-wrap" data-id="element-4340" data-mp="1ol2gcuvtp6ek">
                  <table className="paysys-table" data-id="element-4341" data-mp="1jjvcv80pqtdp">
                    <thead data-id="element-4342" data-mp="1jj3fpsrgwnlb">
                      <tr data-id="element-4343" data-mp="1elbqj6i7jfkt">
                        <th data-id="element-4344" data-mp="1ekjtdr8yp9sf">Txn ID</th>
                        <th data-id="element-4345" data-mp="1ellekojozcnv">MTO</th>
                        <th data-id="element-4346" data-mp="1ajzuai4tvw3n">Amount</th>
                        <th data-id="element-4347" data-mp="1al1iloauuf3b">Action Queue</th>
                        <th data-id="element-4348" data-mp="1am2s3oc82tix">Reason</th>
                        <th data-id="element-4349" data-mp="38zmab0jy3jjq">Severity</th>
                        <th data-id="element-4350" data-mp="38x8kb644gxj1">Action</th>
                      </tr>
                    </thead>
                    <tbody data-id="element-4351" data-mp="34yiwskpddzlo">
                      {transactions.map(row => <tr key={row[0]} data-id="element-4352" data-mp="12aanuuz5ux1x">
                          <td data-id="element-4353" data-mp="171smvdhmink9"><strong data-id="element-4354" data-mp="171sofhx9uvmd">{row[0]}</strong></td>
                          <td data-id="element-4355" data-mp="173dhf33xu6i4">{row[1]}</td>
                          <td data-id="element-4356" data-mp="tae5fb3d6ufb"><strong data-id="element-4357" data-mp="tae0qxsf668z">{row[2]}</strong></td>
                          <td data-id="element-4358" data-mp="tbyz6yhuu9c4"><span className="paysys-chip" data-id="element-4359" data-mp="tc8pyoaq4kiv">{row[3]}</span></td>
                          <td data-id="element-4360" data-mp="xd0ytgfoonem">{row[4]}</td>
                          <td data-id="element-4361" data-mp="x9mwu9axmg7p"><span className={`paysys-chip ${row[5] === 'High' ? 'red' : row[5] === 'Medium' ? 'orange' : 'green'}`} data-id="element-4362" data-mp="x9mva4vaa85l">{row[5]}</span></td>
                          <td data-id="element-4363" data-mp="1pzlrck7wb5jr"><ChevronRight size={18} data-id="element-4364" data-mp="1pzdcwnw4js6g" /></td>
                        </tr>)}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <aside className="paysys-grid" data-id="element-4365" data-mp="1gy5f06xistcw">
              <section className="paysys-card" data-id="element-4366" data-mp="m03ik95ndyh">
                <div className="paysys-card-header" data-id="element-4367" data-mp="k5k5adj7twi">
                  <h2 className="paysys-section-title" data-id="element-4368" data-mp="5lcpl2s7ch00">Settlement Health</h2>
                  <span className="paysys-chip green" data-id="element-4369" data-mp="5igv5ofkcagb"><CheckCircle2 size={14} data-id="element-4370" data-mp="3t8fbnzs7a4uz" /> Stable</span>
                </div>
                <div className="paysys-chart" aria-label="Settlement trend chart preview" data-id="element-4371" data-mp="3p7veiw7mn18u" />
              </section>

              <section className="paysys-card" data-id="element-4372" data-mp="728nljow3gp4">
                <h2 className="paysys-section-title" data-id="element-4373" data-mp="6zw8deainkfr">Control Queue</h2>
                <div className="paysys-status-list" data-id="element-4374" data-mp="2474iyrgrhdn">
                  {['Checker approval SLA', 'Manual settlement audit', 'Alert configuration sync'].map((item, index) => <div className="paysys-status-row" key={item} data-id="element-4375" data-mp="35kdxobc95w86" data-mpi={index}>
                      <span data-id="element-4376" data-mp="3k8ihjin1kdsj">{item}</span>
                      <span className={`paysys-chip ${index === 1 ? 'gold' : 'green'}`} data-id="element-4377" data-mp="3k9k52ml8usr5">{index === 1 ? 'Review' : 'On track'}</span>
                    </div>)}
                </div>
              </section>
            </aside>
          </section>
        </main>
      </div>
    </div>;
}